module.exports = __webpack_public_path__ + "static/media/Audio_Rebeka.ff4f2186.mp3";